module.exports = __webpack_public_path__ + "img/zaid.abb38e30.png";